module.exports = __webpack_public_path__ + "static/media/1_Jens_Winter_Zertifikate.0772db75.jpg";